import { styled } from '@linaria/react';
import { Group, Switch } from '@mantine/core';
import { baseWhite, secondaryBase } from '../../styles/design-tokens';
import { Text } from '../../ui-library/typography/typography';

type UseGroupsSwitchProps = {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const UseGroupsSwitch = ({ label = 'Use Groups', checked, onChange }: UseGroupsSwitchProps) => {
  return (
    <Group gap="xs" wrap="nowrap">
      <Text size="small" style={{ whiteSpace: 'nowrap' }}>
        {label}
      </Text>
      <StyledSwitch checked={checked} onChange={(e) => onChange(e.currentTarget.checked)} />
    </Group>
  );
};

const StyledSwitch = styled(Switch)`
  .mantine-Switch-track {
    height: 25px;
    width: 45px;
    padding: 2px 8px;
    border-radius: 100px;
    border: 2px solid rgba(29, 27, 32, 0.12);
    background: rgba(231, 224, 236, 0.12);
    cursor: pointer;
    box-sizing: border-box;
  }

  .mantine-Switch-thumb {
    height: 14px;
    width: 14px;
    border-radius: 24px;
    margin-left: 2px;
    opacity: 0.38;
    background: #1d1b20;
  }

  input {
    &:checked + .mantine-Switch-track {
      border-color: ${secondaryBase};
      background: ${secondaryBase};

      .mantine-Switch-thumb {
        height: 16px;
        width: 16px;
        background: ${baseWhite};
        z-index: 1;
        left: 22px;
        opacity: 1;
      }
    }
  }
`;
